const controller = {
  'Header.Header.TableHeader': ({ content, orderBy, orderDirection }, outlet) => {
    if (content.sortingField !== orderBy) {
      outlet({ action: 'change_sort', orderDirection: 'asc', orderBy: content.sortingField });
    } else {
      if (orderDirection === 'asc') {
        outlet({ action: 'change_sort', orderDirection: 'desc', orderBy });
      } else {
        outlet({ action: 'change_sort', orderDirection: null, orderBy: null });
      }
    }
  },
  'Header.Header.NameHeader.HeaderCheckbox': ({ }, outlet) => {
    outlet({ action: 'toggle_select' })
  },
  'Header.Header.NameHeader.TableHeader': ({ orderBy, orderDirection, content }, outlet) => {
    controller['Header.Header.TableHeader']({ orderBy, orderDirection, content }, outlet);
  }
}

export default controller;